import React from 'react'
import { FirmSocials } from './socials'
import { Socials } from '../mapper'

export type SocialsWrapperProps = {
  socials: Socials
  color: string | null
}

export const SocialsWrapper: React.FC<SocialsWrapperProps> = ({ socials, color }) => (
  <div className="p-4">
    <h2 className="mb-3 text-lg font-semibold text-left text-night">
      Suivez-nous
    </h2>
    <FirmSocials
      additionalClasses="space-x-2 flex flex-wrap items-center"
      socials={socials}
      color={color}
    />
  </div>
)
